export const COMMON = { MAX_AGE_TWO_WEEKS: 60 * 60 * 24 * 14 };
